import './App.css'
import PageLayout from 'components/Layout/PageLayout'
import AppRoutes from 'routes'
import PageViewTracker from 'components/Analytics/PageViewTracker'
import { LangProvider } from 'contexts/LangContext'
import 'services/translate/i18n'

function App() {
  return (
    <div className="App">
      <PageViewTracker />
      <LangProvider>
        <PageLayout>
          <AppRoutes />
        </PageLayout>
      </LangProvider>
    </div>
  )
}

export default App
